import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  button: {
    backgroundColor: colorsConstants.secondary,
    borderRadius: "10px",
    paddingY: "12px",
    paddingX: "32px",
  },
  text: {
    color: colorsConstants.snackbarTextColor,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
